// Drop-in wrapper for `fetch()` that attaches the shared login's JWT (see
// AuthContext.jsx, which persists it to sessionStorage on login/logout) -
// same token, same storage key ('access_token') the axios-based clients use
// (src/lib/api.js's interceptor, src/pages/lead-finder/api.js, src/pages/
// analyzer/lib/gapApi.js). AI Tender's Dashboard.jsx/GovernmentOpportunities.jsx
// call the backend directly via raw fetch() rather than through an axios
// instance, so they never had a token attached at all - harmless while
// ai_tender's opportunities/search/proposal routes were open, but once those
// routes started requiring the shared login (see SECURITY_AUDIT.md), every
// one of these calls started failing with 401, which is why AI Tender's
// dashboard stopped showing any data.
//
// Usage: swap `fetch(url, options)` for `authedFetch(url, options)` -
// everything else (method, body, response handling) stays identical; this
// only adds an Authorization header when a token is present.
export function authedFetch(url, options = {}) {
  let token = null;
  try {
    token = sessionStorage.getItem('access_token');
  } catch {
    // sessionStorage can throw in some contexts (privacy mode, etc.) -
    // fall back to an unauthenticated request rather than crashing the call.
  }
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return fetch(url, { ...options, headers });
}
